/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DesiredClusterState
 */
export interface DesiredClusterState {
    /**
     * 
     * @type {string}
     * @memberof DesiredClusterState
     */
    desiredStatus?: string;
}

/**
 * Check if a given object implements the DesiredClusterState interface.
 */
export function instanceOfDesiredClusterState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DesiredClusterStateFromJSON(json: any): DesiredClusterState {
    return DesiredClusterStateFromJSONTyped(json, false);
}

export function DesiredClusterStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DesiredClusterState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desiredStatus': !exists(json, 'desired_status') ? undefined : json['desired_status'],
    };
}

export function DesiredClusterStateToJSON(value?: DesiredClusterState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desired_status': value.desiredStatus,
    };
}

